export default customElements.define('w-widget-button', class WidgetButton extends wealthify.CustomElementBaseClass {
    constructor () {
        const styleSelector = 'c-widget-button';
        const config = {
            styleSelector,
            templateHTML: `
                <div data-root>
                    <button class="${styleSelector}__container" type="button" data-widget-button-button>
                        <w-icon data-widget-button-icon></w-icon>
                    </button>
                    <label class="${styleSelector}__container ${styleSelector}__container--label u-display__none" data-widget-button-label>
                        <w-icon data-widget-button-icon></w-icon>
                    </label>
                </div>`,
            cacheDom: [ 'data-widget-button-button', 'data-widget-button-label', 'data-widget-button-icon' ]
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get validContexts () {
        return [ 'button', 'label', 'submit' ];
    }

    static get validTypes () {
        return [ 'circled', 'uncircled' ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('activated', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('context', {
                default: 'button',
                type: wealthify.propTypes.ArrayItem(this.validContexts)
            }),
            new wealthify.Prop('hovered', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('label', {default: ''}),
            new wealthify.Prop('onclickprop', {type: wealthify.propTypes.Function()}),
            new wealthify.Prop('small'),
            new wealthify.Prop('type', {
                default: 'circled',
                type: wealthify.propTypes.ArrayItem(this.validTypes)
            }),
            wealthify.props.Disabled(),
            wealthify.props.Icon({
                default: 'no-icon',
                required: true
            }),
            wealthify.props.Icon({
                name: 'iconactivated',
                default: 'no-icon'
            })
        ];
    }

    get propCallbacks() {
        return {
            activated: () => this._setIcon(),
            context: (value) => {
                const isButton = value === 'button' || value === 'submit';
                const buttonClassListAction = isButton ? 'remove' : 'add';
                const labelClassListAction = isButton ? 'add' : 'remove';

                this.dom.widgetButtonButton.classList[buttonClassListAction]('u-display__none');
                this.dom.widgetButtonLabel.classList[labelClassListAction]('u-display__none');
            },
            disabledprop: () => {
                const classListAction = this.disabledprop ? 'add' : 'remove';

                this.dom.widgetButtonButton.disabled = this.disabledprop;
                this.dom.widgetButtonButton.classList[classListAction](`${this.styleSelector}__container--disabled`);
                this.dom.widgetButtonLabel.classList[classListAction](`${this.styleSelector}__container--disabled`);
            },
            hovered: () => this._setHovered(),
            icon: () => this._setIcon(),
            iconactivated: () => {},
            label: (value) => {
                if (value !== '') {
                    this.dom.widgetButtonButton.setAttribute('aria-label', value);
                    this.dom.widgetButtonLabel.setAttribute('aria-label', value);
                    this.dom.root.setAttribute('aria-hidden', false);
                } else {
                    this.dom.widgetButtonButton.removeAttribute('aria-label');
                    this.dom.widgetButtonLabel.removeAttribute('aria-label');
                    this.dom.root.setAttribute('aria-hidden', true);
                }
            },
            onclickprop: (value) => this.dom.widgetButtonButton.onclick = value.bind(this),
            small: () => {
                const classListAction = this.small ? 'add' : 'remove';

                this.dom.widgetButtonButton.classList[classListAction](`${this.styleSelector}__container--small`);
                this.dom.widgetButtonLabel.classList[classListAction](`${this.styleSelector}__container--small`);
            },
            type: () => {
                this.constructor.validTypes.forEach((type) => {
                    this.dom.widgetButtonButton.classList.remove(`${this.styleSelector}__container--type-${type}`);
                    this.dom.widgetButtonLabel.classList.remove(`${this.styleSelector}__container--type-${type}`);
                });

                this.dom.widgetButtonButton.classList.add(`${this.styleSelector}__container--type-${this.type}`);
                this.dom.widgetButtonLabel.classList.add(`${this.styleSelector}__container--type-${this.type}`);
                this._setHovered();
            }
        };
    }

    _setIcon () {
        const applicableIcon = this.iconactivated && this.activated ? this.iconactivated : this.icon;

        this.dom.widgetButtonIcon.forEach((icon) => {
            icon.type = applicableIcon;
        });
    }

    _setHovered () {
        const classListAction = this.hovered ? 'add' : 'remove';

        this.constructor.validTypes.forEach((type) => {
            this.dom.widgetButtonButton.classList.remove(`${this.styleSelector}__container--hovered-${type}`);
            this.dom.widgetButtonLabel.classList.remove(`${this.styleSelector}__container--hovered-${type}`);
        });

        this.dom.widgetButtonButton.classList[classListAction](`${this.styleSelector}__container--hovered-${this.type}`);
        this.dom.widgetButtonLabel.classList[classListAction](`${this.styleSelector}__container--hovered-${this.type}`);
    }
});